import React, { useEffect } from 'react'
import {SiGeeksforgeeks, SiUdemy} from 'react-icons/si'
import {GrCertificate} from 'react-icons/gr'
import AOS from 'aos';
import 'aos/dist/aos.css'

export default function Achieve() {
  useEffect(()=>{
     AOS.init({duration: 2000});
  }, [])

  return (
    <div>
        <p className='flex justify-center font-cust text-slate-300 sm:text-4xl text-2xl pt-20 sm:pt-40'>My Achievements</p>
        <div className="flex justify-center pt-10 sm:pt-20">
            
            <div className='md:grid md:grid-cols-4 grid grid-cols-2'>
                <div data-aos="fade-right" className="flex justify-center sm:h-40 h-20 sm:w-40 w-20 sm:mx-auto mx-3 bg-gradient-to-b from-slate-600 to-slate-900 rounded-lg shadow-black shadow-xl hover:animate-pulse hover:shadow-red-900 mt-5">
                <a rel='noreferrer' href='https://www.cloudskillsboost.google/public_profiles/d8540813-9183-4d8c-89b1-3cb0e0c91f9f' target='_blank'><img src="https://img.icons8.com/color/240/000000/google-cloud.png" alt=''/></a>
                </div>

                <div data-aos="fade-up"  className="flex justify-center py-3 sm:py-5 text-6xl sm:text-9xl sm:h-40 h-20 sm:w-40 w-20 sm:mx-auto mx-3 bg-gradient-to-b from-slate-600 to-slate-900 rounded-lg shadow-black shadow-xl hover:animate-pulse hover:shadow-green-900 mt-5">
                 <a rel='noreferrer' href='https://drive.google.com/drive/folders/1vvMb_6-anRepfRFA_j6jOJqsAZC_rAFO?usp=sharing' target='_blank'><SiGeeksforgeeks color='#90EE90'/></a>
                </div>

                <div data-aos="fade-up" className="flex justify-center py-3 sm:py-6 text-6xl sm:text-8xl sm:h-40 h-20 sm:w-40 w-20 sm:mx-auto mx-3 bg-gradient-to-b from-slate-600 to-slate-900 rounded-lg shadow-black shadow-xl hover:animate-pulse hover:shadow-violet-900 mt-5">
                  <a rel='noreferrer' href='https://www.udemy.com/certificate/UC-5f3ae525-8802-408b-affb-2ba30ae9874e/' target='_blank'><SiUdemy color='white'/></a>
                </div>

                <div  data-aos="fade-left" className="flex justify-center py-3 sm:py-8 text-6xl sm:text-8xl sm:h-40 h-20 sm:w-40 w-20 mx-3 bg-gradient-to-b from-slate-600 to-slate-900 rounded-lg shadow-black shadow-xl hover:animate-pulse hover:shadow-blue-900 mt-5">
                  <a rel='noreferrer' href='https://drive.google.com/drive/folders/1BPfQ9NYlfDIYqxFPIhZWc0ZioGl4fzE5?usp=sharing' target='_blank'><GrCertificate/></a>
                </div>
            </div> 
        </div>
    </div>
  )
}
